import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのContractorCoreロゴアイコン
 */
export function ProductLogoSmallContractorCore({
  size = 20,
  color = "#0070C0",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.85352 8.5C10.0962 8.5 11.1035 7.49264 11.1035 6.25C11.1035 5.00736 10.0962 4 8.85352 4C7.61088 4 6.60352 5.00736 6.60352 6.25C6.60352 7.49264 7.61088 8.5 8.85352 8.5ZM8.85352 10C10.9246 10 12.6035 8.32107 12.6035 6.25C12.6035 4.17893 10.9246 2.5 8.85352 2.5C6.78245 2.5 5.10352 4.17893 5.10352 6.25C5.10352 8.32107 6.78245 10 8.85352 10Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 9.14645C16.6562 9.05268 16.529 9 16.3964 9H13.1035C12.8274 9 12.6035 9.22386 12.6035 9.5V17.5C12.6035 17.7761 12.8274 18 13.1035 18H18.1035C18.3797 18 18.6035 17.7761 18.6035 17.5V11.2071C18.6035 11.0745 18.5508 10.9473 18.4571 10.8536L16.75 9.14645ZM14.1035 14.8333C14.1035 14.6492 14.2528 14.5 14.4368 14.5H16.7702C16.9543 14.5 17.1035 14.6492 17.1035 14.8333V15.1667C17.1035 15.3508 16.9543 15.5 16.7702 15.5H14.4368C14.2528 15.5 14.1035 15.3508 14.1035 15.1667V14.8333ZM14.4368 11.5C14.2528 11.5 14.1035 11.6492 14.1035 11.8333V12.1667C14.1035 12.3508 14.2528 12.5 14.4368 12.5H16.7702C16.9543 12.5 17.1035 12.3508 17.1035 12.1667V11.8333C17.1035 11.6492 16.9543 11.5 16.7702 11.5H14.4368Z"
        fill={color}
      />
      <path
        d="M11.6035 11H6.10352C3.89438 11 2.10352 12.7909 2.10352 15V15.5C2.10352 16.0523 2.55123 16.5 3.10352 16.5H11.6035V15H3.60352C3.60352 13.6193 4.7228 12.5 6.10352 12.5H11.6035V11Z"
        fill={color}
      />
    </svg>
  );
}
